import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGcr = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 57,
	height: 57,
	viewBox: "0 0 57 57",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M37.2623 18.6771L41.9563 14.0058L42.2691 12.0389C33.7154 4.29872 20.1181 5.17638 12.4073 13.8702C10.2654 16.2849 8.67644 19.2953 7.8291 22.4039L9.51027 22.1682L18.8981 20.6276L19.6228 19.89C23.7988 15.326 30.8595 14.712 35.6811 18.5952L37.2623 18.6771Z",
			fill: "#EA4335"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M48.6433 22.2665C47.5643 18.3126 45.3493 14.7581 42.2694 12.0391L35.6814 18.5951C38.4632 20.8572 40.048 24.2649 39.9801 27.8392V29.0029C43.2182 29.0029 45.8435 31.6153 45.8435 34.8377C45.8435 38.0604 43.2182 40.6073 39.9801 40.6073H28.237L27.084 41.8529V48.8515L28.237 49.9495H39.9801C48.4028 50.0148 55.284 43.3385 55.3496 34.9566C55.3893 29.876 52.8722 25.113 48.6433 22.2665Z",
			fill: "#4285F4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.5103 49.9496H28.2369V40.6071H16.5103C15.6747 40.6069 14.8656 40.4283 14.1058 40.0828L12.4421 40.5908L7.71522 45.262L7.30347 46.8519C9.95432 48.8438 13.1886 49.9639 16.5103 49.9496Z",
			fill: "#34A853"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.5103 19.6441C8.0873 19.6941 1.30017 26.5298 1.35037 34.9117C1.37843 39.5924 3.57513 43.9985 7.30346 46.8519L14.1058 40.0827C11.1545 38.7559 9.84315 35.2996 11.1765 32.3629C12.5096 29.4262 15.9829 28.1211 18.9337 29.4478C20.2341 30.0324 21.2755 31.069 21.863 32.3629L28.6653 25.5938C25.7711 21.8285 21.2739 19.6271 16.5103 19.6441Z",
			fill: "#FBBC05"
		})
	]
});
const ForwardRef = forwardRef(SvgGcr);
export { ForwardRef as ReactComponent };
